import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Globe } from 'lucide-react';
import dlLogo from '../assets/dl-logo.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Main Footer — 5 columns */}
      <div className="footer__main">
        <div className="container footer__grid">
          {/* Column 1: Company Info */}
          <div className="footer__col footer__col--brand">
            <div className="footer__logo">
              <img src={dlLogo} alt="Denver Logistics" className="footer__logo-img" />
            </div>
            <p className="footer__description">
              Denver Logistics Private Limited is committed to delivering reliable, efficient,
              and cost-effective supply chain solutions with precision and professionalism.
            </p>
          </div>

          {/* Column 2: Quick Links — 2 sub-columns */}
          <div className="footer__col">
            <h4 className="footer__heading">Quick Links</h4>
            <div className="footer__links-split">
              <ul className="footer__links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/industries">Industries</Link></li>
              </ul>
              <ul className="footer__links">
                <li><Link to="/global-network">Global Network</Link></li>
                <li><Link to="/contact">Get in Touch</Link></li>
                <li><Link to="/quote">Get a Quote</Link></li>
              </ul>
            </div>
          </div>

          {/* Column 3: Services — 2 sub-columns */}
          <div className="footer__col">
            <h4 className="footer__heading">Our Services</h4>
            <div className="footer__links-split">
              <ul className="footer__links">
                <li><Link to="/services/sea-freight">Sea Freight</Link></li>
                <li><Link to="/services/air-freight">Air Freight</Link></li>
                <li><Link to="/services/land-freight">Land Freight</Link></li>
              </ul>
              <ul className="footer__links">
                <li><Link to="/services/project-logistics">Project Logistics</Link></li>
                <li><Link to="/services/customs-clearance">Customs Clearance</Link></li>
                <li><Link to="/services/warehousing">Warehousing</Link></li>
              </ul>
            </div>
          </div>

          {/* Column 4: Contact */}
          <div className="footer__col">
            <h4 className="footer__heading">Contact Us</h4>
            <ul className="footer__contact">
              <li>
                <Phone size={15} />
                <a href="tel:+919940689572">+91 99406 89572</a>
              </li>
              <li>
                <Mail size={15} />
                <a href="mailto:info@denver-logistics.com">info@denver-logistics.com</a>
              </li>
              <li>
                <Globe size={15} />
                <span>www.denver-logistics.com</span>
              </li>
              <li>
                <MapPin size={15} />
                <span>
                  Sundarbans, No. 70/16, First Floor,<br />
                  1st Avenue, 100 Feet Road,<br />
                  Ashok Nagar, Chennai – 600 083, India
                </span>
              </li>
            </ul>
          </div>

          {/* Column 5: Follow Us */}
          <div className="footer__col">
            <h4 className="footer__heading">Follow Us</h4>
            <div className="footer__social">
              <a href="#linkedin" className="footer__social-link" aria-label="LinkedIn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
              <a href="#facebook" className="footer__social-link" aria-label="Facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="#instagram" className="footer__social-link" aria-label="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>&copy; {new Date().getFullYear()} Denver Logistics Private Limited. All rights reserved.</p>
          <div className="footer__bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
